import { css } from '@emotion/core';

export const $linkList = ({ typographyStyles }) => [
  ...typographyStyles.textS,
  css`
    margin-top: 0;
    padding-inline-start: 20px;
  `
];
